// @ts-nocheck

const isHelpCrunchWindowInit = () => typeof window.HelpCrunch === "function" && !!window.helpcrunchSettings;

export const init = function (onReady) {
  if (isHelpCrunchWindowInit()) {
    onReady();
    return;
  }

  var w = window;
  w.helpcrunchSettings = {
    organization: "shelfcycle",
    appId: "27ab16c4-0291-412a-83c5-7d24b9fd5dfa",
    showWidget: false,
  };
  var d = document;
  var hS = w.helpcrunchSettings;
  if (!hS || !hS.organization) {
    return;
  }
  var widgetSrc = "https://" + hS.organization + ".widget.helpcrunch.com/";
  w.HelpCrunch = function () {
    w.HelpCrunch.q.push(arguments);
  };
  w.HelpCrunch.q = [];
  w.HelpCrunch("onReady", onReady);

  function r() {
    if (d.querySelector(`script[src="${widgetSrc}"`)) {
      return;
    }
    var s = d.createElement("script");
    s.async = 1;
    s.type = "text/javascript";
    s.src = widgetSrc;
    (d.body || d.head).appendChild(s);
  }

  if (d.readyState === "complete" || hS.loadImmediately) {
    r();
  } else if (w.attachEvent) {
    w.attachEvent("onload", r);
  } else {
    w.addEventListener("load", r, false);
  }
};

export const updateUser = function (config) {
  if (isHelpCrunchWindowInit()) {
    window.HelpCrunch("updateUser", {
      user_id: config.userId,
      company: config.orgName,
      email: config.email,
      name: config.name,
    });
  }
};

export const show = () => {
  if (isHelpCrunchWindowInit()) {
    window.HelpCrunch("openChat");
  }
};

export const onUnreadChat = function (callback) {
  if (isHelpCrunchWindowInit()) {
    window.HelpCrunch("onNewUnreadChat", event => {
      callback(event.unreadChats);
    });
  }
};

export const onIncomingMessage = callback => {
  if (isHelpCrunchWindowInit()) {
    window.HelpCrunch("onAgentMessage", e => {
      callback(e.detail.message);
    });
  }
};

export const onChatClose = callback => {
  if (isHelpCrunchWindowInit()) {
    window.HelpCrunch("onChatClose", callback);
  }
};

export const onChatOpen = callback => {
  if (isHelpCrunchWindowInit()) {
    window.HelpCrunch("onChatOpen", callback);
  }
};
